var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SuggestRows from './suggest-rows';
import { getBestBalancePoint, getRowRects, getSteps } from './util';
import { emptyFunc } from 'searchband-frontend-commons/util/func';
import * as CLS from './cls';

var object = PropTypes.object,
    string = PropTypes.string,
    shape = PropTypes.shape,
    func = PropTypes.func,
    arrayOf = PropTypes.arrayOf;

var Suggest = function (_PureComponent) {
    _inherits(Suggest, _PureComponent);

    function Suggest(props) {
        _classCallCheck(this, Suggest);

        var _this = _possibleConstructorReturn(this, (Suggest.__proto__ || Object.getPrototypeOf(Suggest)).call(this, props));

        _this.rowRefs = {};

        _this.handleNextClick = function () {
            _this.setState({
                page: _this.state.page + 1,
                animated: true
            });
        };

        _this.handlePrevClick = function () {
            _this.setState({
                page: _this.state.page - 1,
                animated: true
            });
        };

        _this.setRowRef = function (ref, index) {
            return _this.rowRefs[index] = ref;
        };

        _this.setWrapperRef = function (ref) {
            return _this.wrapperRef = ref;
        };

        var sliceIndex = Math.ceil(props.items.length / 2);

        _this.state = {
            page: 0,
            rows: _this.getRows(sliceIndex),
            sliceIndex: sliceIndex,
            steps: [0],
            animated: false
        };
        return _this;
    }

    _createClass(Suggest, [{
        key: 'componentDidMount',
        value: function componentDidMount(oldProps) {
            this.layout();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(oldProps, oldState) {
            if (oldState.rows !== this.state.rows) {
                this.setSteps();
            }
        }
    }, {
        key: 'layout',
        value: function layout() {
            var _this2 = this;

            var props = this.props;


            if (!props.items.length) {
                return;
            }

            var rowsRects = Object.keys(this.rowRefs).map(function (key) {
                return getRowRects(_this2.rowRefs[key]);
            });
            var sliceIndex = getBestBalancePoint(rowsRects);

            if (sliceIndex !== this.state.sliceIndex) {
                this.setState({
                    sliceIndex: sliceIndex,
                    rows: this.getRows(sliceIndex)
                });
            } else {
                this.setSteps();
            }
        }
    }, {
        key: 'setSteps',
        value: function setSteps() {
            var _this3 = this;

            var containerRect = this.wrapperRef.getBoundingClientRect();
            var rowsRects = Object.keys(this.rowRefs).map(function (key) {
                return getRowRects(_this3.rowRefs[key]);
            });

            var steps = getSteps(rowsRects, containerRect);

            this.setState({
                steps: steps,
                page: 0
            });
        }
    }, {
        key: 'getRows',
        value: function getRows(sliceIndex) {
            var items = this.props.items;


            if (items.length <= 3) {
                return [items];
            }

            return [items.slice(0, sliceIndex), items.slice(sliceIndex)];
        }
    }, {
        key: 'render',
        value: function render() {
            var props = this.props;


            if (props.items.length === 0) {
                return null;
            }

            var state = this.state;
            var page = state.page,
                steps = state.steps,
                animated = state.animated;

            var singlePage = steps.length === 1;
            var transform = 'translateX(' + steps[page] + 'px)';
            var showLeftArrow = !singlePage && page > 0;
            var showRightArrow = !singlePage && page < steps.length - 1;

            return React.createElement(
                'div',
                { className: CLS.suggest({ singlePage: singlePage })() },
                React.createElement('div', {
                    className: CLS.arrow({
                        left: true,
                        visible: showLeftArrow
                    })(),
                    onClick: this.handlePrevClick
                }),
                React.createElement(
                    'div',
                    {
                        className: CLS.wrapper({ animated: animated })(),
                        style: { transform: transform },
                        ref: this.setWrapperRef
                    },
                    React.createElement(SuggestRows, {
                        rows: state.rows,
                        onItemClick: props.onAction,
                        setRowRef: this.setRowRef,
                        borderColor: props.borderColor,
                        color: props.color,
                        backgroundColor: props.backgroundColor
                    })
                ),
                React.createElement('div', {
                    className: CLS.arrow({
                        right: true,
                        visible: showRightArrow
                    })(),
                    onClick: this.handleNextClick
                })
            );
        }
    }]);

    return Suggest;
}(PureComponent);

Suggest.defaultProps = {
    items: [],
    onAction: emptyFunc
};
Suggest.propTypes = {
    items: arrayOf(shape({
        title: string.isRequired,
        payload: object.isRequired
    })).isRequired,
    onAction: func.isRequired
};
export default Suggest;